<ion-app [ngClass]="generalClass" lang="{{lang}}">
  <shared-register-page *ngIf="isUserLogged() && isRegisterPending() && isNotSettingsPage()"></shared-register-page>
  <shared-notice-popover-component *ngIf="isUserLogged() && !isRegisterPending()"></shared-notice-popover-component>
  <ion-router-outlet></ion-router-outlet>
  <mobile-alert></mobile-alert>
</ion-app>